var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.134 17.751C37.134 26.157 29.5596 33.1396 19.9977 33.1396C10.4358 33.1396 2.86133 26.157 2.86133 17.751C2.86133 9.34497 10.4358 2.3623 19.9977 2.3623C29.5596 2.3623 37.134 9.34497 37.134 17.751Z",
    fill: "url(#paint0_linear_863_306)",
    stroke: "#EAEAEA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.797 14.9519H15.1636V25.5543H11.797V14.9519ZM13.3945 13.6257H13.3701C12.1514 13.6257 11.3613 12.8152 11.3613 11.7889C11.3613 10.7415 12.1748 9.94702 13.4178 9.94702C14.6599 9.94702 15.4236 10.7395 15.448 11.7859C15.448 12.8122 14.6599 13.6257 13.3945 13.6257ZM28.634 25.5553H24.8165V20.0677C24.8165 18.6316 24.2194 17.6522 22.9063 17.6522C21.9019 17.6522 21.3433 18.3128 21.0833 18.9514C20.9858 19.1793 21.0011 19.4981 21.0011 19.8179V25.5553H17.2191C17.2191 25.5553 17.2678 15.8354 17.2191 14.9519H21.0011V16.6159C21.2245 15.8883 22.433 14.85 24.3616 14.85C26.7542 14.85 28.634 16.376 28.634 19.659V25.5553Z",
    fill: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_863_306",
    x1: 19.9977,
    y1: 1.3623,
    x2: 19.9977,
    y2: 34.1396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamLn);
export default __webpack_public_path__ + "static/media/team-ln.1022e46dbd5ce61c349d13ce80ed70fa.svg";
export { ForwardRef as ReactComponent };